import { AuthErrorCode, authErrorMessages } from '@app/core/auth/errors/auth-errors';
import { useQueryParam } from '@mi-front/core';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { Box, Typography } from '@mui/material';
import { defineMessage, FormattedMessage, useIntl } from 'react-intl';

const errorTitleMessage = defineMessage({
  id: 'auth.loginScreen.errorTitle',
  defaultMessage: 'No se pudo iniciar sesión',
});

/**
 * Reads login_error from the URL and shows a localized title + message.
 * Unknown codes fall back to ERR_AUTH_FAILED. Styled for the splash-based error screen.
 */
export function LoginErrorAlert() {
  const { $t } = useIntl();
  const loginErrorCode = useQueryParam('login_error');

  if (!loginErrorCode) {
    return null;
  }

  // Known codes get their specific copy; anything else falls back to the generic auth failure.
  const messageDescriptor = Object.prototype.hasOwnProperty.call(authErrorMessages, loginErrorCode)
    ? authErrorMessages[loginErrorCode as AuthErrorCode]
    : authErrorMessages.ERR_AUTH_FAILED;

  const displayMessage = $t(messageDescriptor);

  return (
    <>
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
        }}
      >
        <WarningAmberRoundedIcon color="warning" fontSize="small" />
        <Typography variant="h6" color="text.primary" component="h1">
          <FormattedMessage {...errorTitleMessage} />
        </Typography>
      </Box>
      <Typography variant="body2" color="text.secondary">
        {displayMessage}
      </Typography>
    </>
  );
}
